import React, { useEffect, useMemo } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Header from "../../../policy/fragments/heading";
import { Iconfont } from "../../../../components/icon/iconfont";
import { useIntl } from "react-intl";
import { fetchGetMessage, fetchShareUrl } from "../../../../../api";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { fetchUnifiedProcessing } from "../../utils";
import { useRef } from "react";
import { useCallback } from "react";
import Alert from "../../../../components/alert";
import Copy from 'copy-to-clipboard';
import { useDispatch, useSelector } from "react-redux";
import { useStore } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "../../../../hooks/common";
import ShareToFace from "../../../details/tools/share-to-face";
import ShareEmailModal from "./components/share-email";
import { setCustomerLoading } from "../../../../../store/actions/pages/customer";
import { BlackMask } from "../../../../components/mask";


const ShareRulesModal = props =>{
    const { onClose, rulesHtml } = props;

    const disposeRulesHtml = useMemo(() =>{
        if(rulesHtml?.message){
            let str = rulesHtml.message.replace(/ACUMINPRO-BOLD/g, "Roboto-Bold");
            str = str.replace(/SLATEPRO/g, "Roboto");
            return str;
        }
    }, [rulesHtml]);

    return <React.Fragment>
        <div className={cls.ShareRulesModal}>
            <div className={cls.ShareRules}>
                <div className={cls.Hd}>
                    <FormattedMessage id="rules" defaultMessage="Rules" />
                    <Iconfont className={cls.Close} onClick={onClose}>&#xe7c9;</Iconfont>
                </div>

                <div className={cls.Bd}>
                    <div dangerouslySetInnerHTML={{ __html: disposeRulesHtml }}></div>
                </div>
            </div>
        </div>

        <BlackMask />
    </React.Fragment>
}

const ShareLink = props =>{
    const { title, opsitonList } = props;
    return <div className={cls.ShareLink}>
        <div className={cls.Title}>
            {title}
        </div>

        <div className={cls.ProcessContainer}>
            {
                opsitonList?.map((item, index)=>(
                    <React.Fragment key={item.id+index}>
                        <div className={cls.ContentItem}>
                            <div>
                            <Iconfont className={cls.Icon} dangerouslySetInnerHTML={{__html: item.icon}}></Iconfont>
                            </div>
                            <p className={cls.Font}>{item.title}</p>
                        </div>

                        {
                            !item?.noRightIcon && <Iconfont className={cls.JtItem}>&#xe78d;</Iconfont>
                        }
                    </React.Fragment>
                ))
            }
        </div>

        {props?.children}
    </div>
}

const HowDoesWork = props =>{
    const { urls } = props;
    const Intl = useIntl();
    const howWorkList = useRef([
        {
            id:1,
            icon:"&#xe707",
            title:Intl.formatMessage({ id: "share_the_link", defaultMessage: "Share the link" })
        },
        {
            id:2,
            icon:"&#xe78f",
            title:Intl.formatMessage({ id: "register", defaultMessage: "Register" })
        },
        {
            id:3,
            icon:"&#xe698",
            title:Intl.formatMessage({ id: "reward", defaultMessage: "Reward" }),
            noRightIcon:true
        }
    ]);

    const handleClick = useCallback((number) =>{
        if (Copy(number)) {
            Alert(Intl.formatMessage({ id: "copied_successfully", defaultMessage: "Copied Successfully" }));
		
            if(window.GeekoSensors){
                window.GeekoSensors.Track('ActivityShare', {
                    page_type: window.sourceTitle || window.currentPage,
                    share_type:"link",
                    activity_type:"注册分享"
                })

            }
        } else {
			Alert(Intl.formatMessage({ id: "copy_fail", defaultMessage: "copy failed! try again" }));
		}
    }, []);

    return <ShareLink 
            title={Intl.formatMessage({ id: "how_does_it_works", defaultMessage: "How does it works?" })}
            opsitonList={howWorkList.current}
        >
        <div className={cls.InvitationLink}>
            <span className={cls.ShareBtn} onClick={()=>handleClick(urls?.unknown)}>
                <span className={cls.ShareValue}>{urls?.unknown || "loading..."}</span>
                <Iconfont className={cls.Icon}>&#xe776;</Iconfont>
            </span>
        </div>
    </ShareLink>
}

const GetMoreReward = props =>{
    const { customer } = props;
    const Intl = useIntl();

    const getMoreList = useRef([
        {
            id:1,
            icon:"&#xe6ae;",
            title:Intl.formatMessage({ id: "share_the_code", defaultMessage: "Share the code" })
        },
        {
            id:2,
            icon:"&#xe7d0;",
            title:Intl.formatMessage({ id: "download_app", defaultMessage: "Download APP" })
        },
        {
            id:3,
            icon:"&#xe78f;",
            title:Intl.formatMessage({ id: "register", defaultMessage: "Register" }),
        },
        {
            id:4,
            icon:"&#xe698;",
            title:Intl.formatMessage({ id: "reward", defaultMessage: "Reward" }),
            noRightIcon:true
        }
    ]);

    const handleClick = useCallback((value) =>{
        if (Copy(value)) {
            Alert(Intl.formatMessage({ id: "copied_successfully", defaultMessage: "Copied Successfully" }));
            
            if(window.GeekoSensors){
                window.GeekoSensors.Track('ActivityShare', {
                    page_type: window.sourceTitle || window.currentPage,
                    share_type:"code",
                    activity_type:"注册分享"
                })

            }
        } else {
			Alert(Intl.formatMessage({ id: "copy_fail", defaultMessage: "copy failed! try again" }));
		}
    }, []);
    
    return <ShareLink 
        title={Intl.formatMessage({ id: "get_more_rewards", defaultMessage: "Wanna get more rewards?" })}
        opsitonList={getMoreList.current}
    >
        <div className={cls.GetMoreRewardLink}>
            <span className={cls.ShareBtn} onClick={()=>handleClick(customer?.invitationCode)}>
                <span><FormattedMessage id="reward" defaultMessage="Reward" />:</span>
                <span className={cls.ShareValue}>{customer?.invitationCode || "loading..."}</span>
                <Iconfont className={cls.Icon}>&#xe776;</Iconfont>
            </span>
        </div>
    </ShareLink>
}

const SharePoints = props =>{
    const { customer } = props;

    return <div className={cls.SharePoints}>
        <div className={cls.SharePointItem}>
            <p><FormattedMessage id="friends_invited" defaultMessage="Friends Invited" /></p>
            <p>{customer?.invitedFriends || 0}</p>
        </div>

        <div className={cls.SharePointItem}>
            <p><FormattedMessage id="points_earned" defaultMessage="Points Earned" /></p>
            <p>{customer?.invitedFriendsPointsEarned || 0}</p>
        </div>
    </div>
}

const ShareWayWith = props =>{
    const { urls, setShowModal } = props;

    return <div className={cls.ShareWayWith}>
        <div className={cls.Title}><FormattedMessage id="share_with" defaultMessage="Share With" /></div>

        <div className={cls.Container}>
            <ShareToFace 
                shareUrl={urls?.facebook}
                quote={"SHARE UP TO 50% OFF , GET $10"}
            >
                <span className={cls.Item}>
                    <Iconfont>&#xe79c;</Iconfont>
                </span>
            </ShareToFace>
            

            <span className={cls.Item} onClick={() =>setShowModal(true)}>
                <Iconfont>&#xe721;</Iconfont>
            </span>
        </div>
    </div>
}

const ReferFriend =  props =>{
    useStyles(cls);
    const Intl = useIntl();
    const [message1630, setMessage1630] = useState(null);
    const [urls, setUrls] = useState(null);
    const store = useStore();
    const params = useParams();
    const query = useQuery();
    const dispatch = useDispatch();
    const pageCustomer = useSelector(state=>state.pageCustomer);
    const { customer } = pageCustomer;
    const [showModal, setShowModal] = useState(false);
    const [showRulesModal, setShowRulesModal] = useState(false);
    const [rulesHtml, setRelusHtml] = useState(null);

    useEffect(async () =>{
        let fetchData = await Promise.all([fetchShareUrl({urlCode:"R00R",activityCode:"1000",params:JSON.stringify({share:1})}), fetchGetMessage("M1630")]);
        let [response1, response2] = fetchData;
        setUrls(fetchUnifiedProcessing(response1));
        setMessage1630(fetchUnifiedProcessing(response2));
    }, []);

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			await ReferFriend.fetchData(store, params, query)
		}
    }, []);

    const showRulesHandle = useCallback(async () =>{
        if(!rulesHtml){
            dispatch(setCustomerLoading(true));
            let response = await fetchGetMessage("M1629");
            setRelusHtml(fetchUnifiedProcessing(response));
            dispatch(setCustomerLoading(false));
        }
        setShowRulesModal(true);
    }, [rulesHtml]);

    return <div className={cls.ReferFriend}>
        <Header 
            centerSlot={Intl.formatMessage({ id: "refer_a_friend", defaultMessage: "Refer a Friend" })} 
            rightSlot={
                <a className={cls.RightIcon} onClick={showRulesHandle}>
                    <Iconfont className={cls.Icon}>&#xe73f;</Iconfont>
                </a>
            }
        />

        <div className={cls.ShareContainer}>
            <div className={cls.ShareTopTitle} dangerouslySetInnerHTML={{__html: Intl.formatMessage({ id: "share_friend_points_shop", defaultMessage: "You will get up to <span class='font-italic'>200 points</span>,and your Friend will get up to <span class='font-italic'>300 points</span> to shop!" })}}></div>
            <div className={cls.ShareExplain}>
                <span><FormattedMessage id="for_limited_time_only" defaultMessage="For limited time only!" /></span>
                {
                    message1630?.message && <span>{message1630.message}</span>
                }
            </div>

            <HowDoesWork urls={urls} />

            <GetMoreReward customer={customer} />

            <SharePoints customer={customer} />
        </div>

        <ShareWayWith urls={urls} setShowModal={setShowModal} />

        <ShareEmailModal 
            show={showModal}
            onClose={() => setShowModal(false)} 
            exChange={message1630?.message} 
            shareUrl={query?.faceurl || urls?.email}
        />

        {
            rulesHtml && showRulesModal &&  <ShareRulesModal rulesHtml={rulesHtml} onClose={() =>{setShowRulesModal(false)}} />
        }
    </div>
}

ReferFriend.fetchData = async (store, params, search, headers) => {
}

export default ReferFriend;